<template>
  <WebSite/> 
</template>

<script setup>

import WebSite from '@/components/OurPages/WebSite.vue'
</script>